
(function(template){
define('vue!app/views/vue/components/cartComponent/addGuestComponent/container',['Vue','helpers','vuex','vue!./loginComponent','vue!./groupMemberDropdown','vue!./addGroupMember'],function(Vue,helpers,vuex,loginComponent,groupMemberDropdown,addGroupMember){
    return {
        template: template,
        components: {
            'login-component': loginComponent,
            'group-member-dropdown': groupMemberDropdown,
            'add-group-member' : addGroupMember
        },
        computed: vuex.mapState(['loggedInUser','groupMembers','activeStep','desktopMode','loggedInUser','showMobileItineraryDropDown']),
        data: function(){
            return {
                showLoginForm: false,
                showDropdown: false,
                showAdd: false,
            }
        },
        methods: {
            handleAddClick: function(){
                if(!this.loggedInUser)  this.showLoginForm=true;
                else this.showDropdown=true;
                this.$store.commit('setShowMobileItineraryDropDown',false)
            },
            toggleLoginForm: function(bool){
                this.showLoginForm = bool;
            },
            toggleShowAdd: function(bool){
                this.showAdd = bool
            }
        },
        watch: {
            loggedInUser: function(val){
                if(!!val) {
                    this.showLoginForm= false;
                    this.showDropdown= true;
                    this.showAdd= false;
                }
            },
            groupMembers: function(){
                this.showLoginForm= false;
                this.showDropdown= true;
            },
            showDropdown:function(val){
               
            }
        }
    }
})
})('<div id="add-guest-div"> <div v-on:click ="handleAddClick" role="button" aria-label="Add Guest" v-show="!showLoginForm && !showDropdown" id="add-more-div"> <p v-if="desktopMode">{{localStrings.addGroupMember}}</p> <i v-else class="fas fa-user login-mobile-icon" :class="loggedInUser?\'fa-user-plus\':null"></i> </div> <login-component v-if="showLoginForm" @toggle-Login-Form ="toggleLoginForm" ></login-component> <group-member-dropdown v-if="showDropdown " @toggle-Show-Add="toggleShowAdd" ></group-member-dropdown> <add-group-member v-if="showAdd" @toggle-Show-Add="toggleShowAdd" ></add-group-member> </div>');
